<template>
  <div class="content">
    <el-menu default-active="classroom-manage" class="el-menu-demo" mode="horizontal" :router="true">
      <el-menu-item index="manage" class="is-active">专题管理</el-menu-item>
      <el-menu-item index="competition">竞赛管理</el-menu-item>
    </el-menu>

    <div class="tab-item">
      <div class="release">
        <div class="status_wrapper">
          <el-button type="primary" @click="dialogTableVisible = true">创建专题</el-button>
        </div>
        <el-dialog title="创建专题" :visible.sync="dialogTableVisible" @close="close">
          <div class="create-content">
            <el-form ref="createForm" :model="createForm" :rules="createRules" @submit.native.prevent>
              <el-form-item label="专题标题" prop="title" label-width="100px">
                <el-input v-model="createForm.title" name="title" placeholder="请输入标题" @keyup.enter.native="submitForm('createForm', handleCreate)"></el-input>
              </el-form-item>

              <div class="form-item submit_wrapper">
                <div class="input-block">
                  <el-button type="primary" @click="submitForm('createForm', handleCreate)">开始创建</el-button>
                  <el-button @click="close()">取消</el-button>
                </div>
              </div>
            </el-form>
          </div>
        </el-dialog>
        <el-table :data="list" style="width: 100%" :header-cell-style="{ background: '#f5f5f5', color: '#555' }">
          <el-table-column prop="index" label="序号" width="150" type="index"></el-table-column>
          <el-table-column prop="title" label="专题名称" width="350"></el-table-column>
          <el-table-column prop="courseNum" label="应用数" width="180">
            <template slot-scope="scope">
              {{ scope.row.courseNum }}
              <router-link :to="{
                  name: 'classroom-contest',
                  params: { classroomId: scope.row.id }
                }">详情</router-link>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态">
            <template slot-scope="scope">
              {{
                scope.row.status === "published"
                  ? "已发布"
                  : scope.row.status === "draft"
                  ? "未发布"
                  : "已关闭"
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <el-button size="medium" @click="edit(scope.row.id)">编辑</el-button>
              <el-button size="medium" @click="remove(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination @current-change="handle" background layout="total, prev, pager, next" :total="paging.total" :page-size="paging.limit" v-show="paging" hide-on-single-page>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import { getClassroomList, createClassroom, closeClassroom } from "@/api/classroom";
export default {
  components: {},
  inject: ["reload"],
  methods: {
    remove(id) {
      var that = this;
      this.$confirm("删除后将不可恢复！是否删除组合？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          closeClassroom(id).then(response => {
            this.$message.success({
              message: "删除成功"
            });
            that.handle();
          });
        })
        .catch(() => { });
    },
    close() {
      this.dialogTableVisible = false;
      // this.$refs['competionAdd'].closeCreate();
    },
    submitForm(formName, nextFunction) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          nextFunction();
        } else {
          return false;
        }
      });
    },
    handleCreate() {
      let that = this;

      let params = this.createForm;
      params["showable"] = 1;
      params["buyable"] = 1;
      var data = [];

      createClassroom(qs.stringify(params)).then(response => {
        this.$message.success({
          message: "添加成功",
          duration: 2000,
          onClose: function () {
            // that.$emit("fetchData");
            that.close();
            that.edit(response.data);
            that.createForm.title = "";
          }
        });
      });
    },
    handle(val) {
      var params = this.$route.params;
      params.page = val;
      params.status = 4;
      getClassroomList(params).then(response => {
        this.list = response.data.classroomInfo;
        this.paging = response.data.paginator;
      });
    },
    edit(id) {
      this.$router.push({
        name: "classroom-base",
        params: { classroomId: id }
      });
    },
    addClassroom() {
      this.$router.push({
        name: this.course.type + "-base",
        params: { competitionId: this.course.id }
      });
    }
  },
  data() {
    return {
      paging: {
        page: null,
        limit: null,
        total: null
      },
      dialogTableVisible: false,
      value: "",
      list: [],
      course: {
        type: "classroom",
        id: 1
      },
      createForm: {
        title: ""
      },
      createRules: {
        title: [
          { required: true, trigger: "change", message: "请输入标题" },
          {
            min: 1,
            max: 30,
            message: "请输入1-30 个字符",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {
    this.handle();
  },

};
</script>

<style scoped>
.content {
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}
.create-content {
  margin: 20px auto 0;
  background-color: #ffffff;
  padding: 20px;
  overflow: auto;
}
.submit_wrapper {
  text-align: center;
}
.el-card {
  line-height: 32px;
  margin-bottom: 20px;
}
.status_wrapper {
  margin-bottom: 15px;
}
.tab-item ul {
  width: 800px;
  overflow: hidden;
  float: left;
}
.tab-item ul li {
  margin-left: 10px;
  display: block;
  padding: 5px 15px;
  cursor: pointer;
  float: left;
}
.active {
  background-color: #1e9fff;
  color: #ffffff;
}
.tab-item {
  overflow: hidden;
}
.el-menu {
  margin-bottom: 15px;
}
</style>
